import React from 'react';

const posts = [
  {
    id: 1,
    platform: 'linkedin',
    embedUrl: 'https://www.linkedin.com/embed/feed/update/urn:li:share:7426610941607383040?collapsed=1%22',
  },
  {
    id: 2,
    platform: 'linkedin',
    embedUrl: 'https://www.linkedin.com/embed/feed/update/urn:li:share:7402682860974964737?collapsed=1%22',
  },
  // ✅ Add more posts here
];

const LinkedInIcon = () => (
  <svg className="w-5 h-5" viewBox="0 0 24 24" fill="#0A66C2">
    <path d="M20.45 20.45h-3.554v-5.57c0-1.328-.025-3.037-1.852-3.037
             -1.854 0-2.137 1.446-2.137 2.94v5.667H9.353V9h3.414v1.561h.048
             c.476-.9 1.637-1.852 3.37-1.852 3.601 0 4.267 2.37 4.267 5.455v6.286z
             M5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm
             1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0
             1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24
             22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const SocialMediaPost = () => {
  return (
    <section className="w-full max-w-6xl mx-auto px-6 sm:px-12 lg:py-16 py-10">

      {/* Section Header */}
      <div className="flex flex-col items-center gap-3 mb-12">
        <div className="flex items-center gap-3">
          <div className="h-[1px] w-10 bg-[#00C76A] opacity-60" />
          <span className="text-xs tracking-[3px] uppercase text-gray-400 dark:text-gray-500 font-['DM_Sans']">
            As Seen On
          </span>
          <div className="h-[1px] w-10 bg-[#00C76A] opacity-60" />
        </div>
        <div className="flex items-center gap-2">
          <LinkedInIcon />
          <h2 className="font-['Bebas_Neue'] text-3xl text-gray-900 dark:text-gray-100 tracking-wide">
            LinkedIn
          </h2>
        </div>
      </div>

      {/* Posts Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 justify-items-center">
        {posts.map((post) => (
          <div
            key={post.id}
            className="w-full border border-[#00C76A]/20 rounded-xl overflow-hidden
                       shadow-sm hover:shadow-[0_0_24px_rgba(0,199,106,0.08)]
                       hover:border-[#00C76A]/50 transition-all duration-300
                       bg-white dark:bg-[#0E1510]"
          >
            {/* Card Header */}
            <div className="flex items-center gap-2 px-4 py-3 border-b border-gray-100 dark:border-gray-800">
              <LinkedInIcon />
              <span className="text-xs font-semibold text-[#0A66C2]">LinkedIn</span>
            </div>

            {/* Embed */}
            <iframe
              src={post.embedUrl}
              height="500"
              width="100%"
              frameBorder="0"
              allowFullScreen
              title={`LinkedIn Post ${post.id}`}
              className="w-full"
            />
          </div>
        ))}
      </div>

    </section>
  );
};

export default SocialMediaPost;